/* eslint-disable fp/no-mutation */
import {createAction, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {getTaxDisplayLogic} from 'configs/taxDisplayLogic'
import {urlParams} from 'utils/urlParams'
import {OfferCheck, OfferCheckRequestParamsType} from 'types/OfferCheck'
import {OfferPrice} from '@daedalus/core/src/offer/types/offer'
import {updateAllPrices} from 'modules/rooms/updateAllPrices'

export interface OfferCheckState extends OfferCheck {
  loaded: boolean
}

interface OfferCheckPayload {
  data: OfferCheck
}

export const initialState: OfferCheckState = {
  checkInInstructions: '',
  cancellationPenalties: [],
  extraParams: {},
  links: [],
  merchantOfRecord: '',
  prices: [],
  refundable: false,
  status: '',
  providerTraderInformation: null,
  loaded: false,
  moduleState: ''
}

export const updatePrices = (prices: OfferPrice[]): OfferPrice[] => {
  const {userCountry} = urlParams()
  const taxDisplayLogic = getTaxDisplayLogic(userCountry)
  return prices.map(price => updateAllPrices(price, taxDisplayLogic))
}

const {actions, reducer} = createSlice({
  name: 'offerCheck',
  initialState,
  reducers: {
    offerCheckDone: {
      reducer: (
        state: OfferCheckState,
        action: PayloadAction<OfferCheckPayload>
      ) => {
        const {data} = action.payload
        const prices = updatePrices(data.prices)
        state = {...data, prices, loaded: true, moduleState: action.type}
        return state
      },
      prepare: response => {
        const {headers, data} = response
        return {
          payload: {
            data
          },
          meta: {
            headers
          }
        }
      }
    },
    offerCheckClear: () => {
      return initialState
    },
    offerCheckError: (state: OfferCheckState, action) => {
      state.moduleState = action.type
    },
    offerCheckPending: () => {
      return initialState
    }
  }
})

export const offerCheck = createAction<OfferCheckRequestParamsType>(
  'offerCheck/offerCheck'
)

export const offerCheckFatalError = createAction(
  'offerCheck/offerCheckFatalError'
)

export const {
  offerCheckDone,
  offerCheckClear,
  offerCheckError,
  offerCheckPending
} = actions

export type Actions =
  | typeof offerCheck
  | typeof offerCheckDone
  | typeof offerCheckClear
  | typeof offerCheckError
  | typeof offerCheckPending
  | typeof offerCheckFatalError

export default reducer
